import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TProvider, adaptProviderFromResponse } from 'src/store';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_PROVIDER } from '../../backend-paths';


export const providerDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_ADMIN_PROVIDER}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ADMIN_PROVIDER}/${payload}`;

		return HttpService.delete(path).then(result => {
			return adaptProviderFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProvider> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const providerDeleteSlice = createSlice({
	name: 'providerDeleteSlice',
	initialState,
	reducers: {
		clearProviderDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[providerDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[providerDeleteApi.fulfilled.type]: (state, action: PayloadAction<TProvider>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[providerDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProviderDeleteSelector = () => useAppSelector(state => state[providerDeleteSlice.name]);

export const { clearProviderDelete } = providerDeleteSlice.actions;
